import "./Footer.css";
import { Link } from "react-router-dom";
import MARTSDB from "../MARTS-DB.svg";
import { useNavigate, useLocation } from "react-router-dom";
import ExternalLink from "./ReactionTable/externalLink.js";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import axios from "../api/axios.js";

function Footer({reloadQuick}) {

  const [lastUpdate, setLastUpdate] = useState(null);

  async function fetchStats() {
    const stats = await axios.post("/statspage");
    setLastUpdate(stats.data.lastUpdate);
  }

  useEffect(() => {
    fetchStats();
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div
      className="row justify-content-left"
      id="BackgroundUpper"
      style={{
        boxShadow:
          "0 5px 20px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.2)",
      }}
    >
      <div className="col-sm-12">
        <div id="Footer" >
          <div style={{ display: 'flex' }}>
  <ul id="ulFooter" style={{ flex: 1, listStyle: 'none' }}>
    <li id="listValue">
      <Link id="FooterLink" to="/browse/molecules">Browse & Search molecules</Link>
    </li>
    <li id="listValue">
      <Link id="FooterLink" to="/browse/mechanisms">Browse & Search mechanisms</Link>
    </li>
    <li id="listValue">
      <Link id="FooterLink" to="/browse/enzymes">Browse & Search enzymes</Link>
    </li>
    <li id="listValue">
      <Link id="FooterLink" to="/downloadpage">Download</Link>
    </li>
    
  </ul>

  <ul id="ulFooter" style={{ flex: 1, listStyle: 'none' }}>
   {/*<li id="listValue">
      <Link id="FooterLink" to="/advancedsearch">Advanced search</Link>
    </li>*/} 
    <li id="listValue">
      <Link id="FooterLink" to="/submit">Submit entry</Link>
    </li>
    <li id="listValue">
      <Link id="FooterLink" to="/statistics">Statistics</Link>
    </li>
    <li id="listValue">
      <Link id="FooterLink" to="/aboutpage">Help</Link>
    </li>
  </ul>
</div>
        </div>
        <div className="row justify-content-left" id="BackgroundLower">
          <div className="col-md-6">
            <div style={{ display: "flex", alignItems: "center" }}><Link  style={{
                  padding: 0,
                  margin: 0,
                  backgroundColor: "rgb(239, 239, 239)",
                  border: "none",
                }}
                to="/"
                //onClick={()=>{navigate("/");
                  //if (location.pathname === "/") {
                  //  reloadQuick()
                  //}
                //}}
                >
                <img src={"/icon_M.png"} alt={"marts logo"} style={{width: "50px"}} /></Link>
                <p style={{marginTop: "10px"}}><b> MARTS-DB </b> last updated: {lastUpdate ? (new Date(lastUpdate[0].lastUpdate)).toLocaleDateString() : "Loading..."}</p>
                </div>
                <p>Cite us: <ExternalLink
            idLink={`linkMarts`}
            idDiv={`divMarts`}
            icon={faExternalLink}
            externalLink={"https://doi.org/10.1186/s12859-025-06341-8"}>
            {"At BMC bioinformatics"}
          </ExternalLink>: <i style={{fontSize: "14px"}}>Martin Engst, Martin Brokeš, Tereza Čalounová, Raman Samusevich, Roman Bushuiev, Anton Bushuiev, Ratthachat Chatpatanasiri, Safa Mert Akmeşe, Adéla Tajovská, Milana Perković, Matouš Soldát, Josef Sivic, Tomáš Pluskal </i> <br/>
              <b style={{fontSize: "15px"}}>MARTS-DB: A Database of Mechanisms And Reactions of Terpene Synthases</b></p>
          </div>
          <div className="col-md-6" align="right" id="FooterIOCB">
            <a href="https://pluskal.group.uochb.cz/en"><img src={`/PluskalGroup_logo.svg`} alt="LabLogo" style={{maxWidth:"80px", float: "right"}}/></a>
            This project has been funded by Tomáš Pluskal group: <br />{" "}
            <Link to="https://www.pluskal-lab.org" id="IOCBLink">
              Biochemistry of Plant Specialized Metabolites
            </Link>           
          </div>
        </div>
        <div className="row justify-content-left" id="BackgroundLower">
          <p >This work is licensed under <a href="https://creativecommons.org/licenses/by/4.0/?ref=chooser-v1" target="_blank" rel="license noopener noreferrer" style={{display: "inline-block"}}>CC BY 4.0 <img style={{height:"22px", marginLeft: "3px", verticalAlign: "text-bottom"}} src="https://mirrors.creativecommons.org/presskit/icons/cc.svg?ref=chooser-v1" alt=""/>
          <img style={{height:"22px", marginLeft: "3px", verticalAlign: "text-bottom"}} src="https://mirrors.creativecommons.org/presskit/icons/by.svg?ref=chooser-v1" alt=""/></a></p> 
          </div>
      </div>
    </div>
  );
}

export default Footer;
